/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EqualityJoinCondition } from './EqualityJoinCondition';

export type JoinStep = {
    datasetId?: string;
    joinCondition?: EqualityJoinCondition;
    joinType?: JoinStep.joinType;
};

export namespace JoinStep {

    export enum joinType {
        INNER = 'Inner',
        LEFT = 'Left',
        RIGHT = 'Right',
        OUTER = 'Outer',
    }


}
